import React, {useState} from "react";
import {Link} from "react-router-dom";
import {useCollection, useDocument} from "react-firebase-hooks/firestore";
import LoadingScreen from "../../LoadingScreen";
import TabContainer from "react-bootstrap/TabContainer";
import "../surveyAdherence.css";
import {firestore} from "../../../firebase";
import AdminNavbar from "../../AdminNavbar";
import {useHistory} from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import NavItem from "react-bootstrap/NavItem";

import {Button, Col, Container, Form, FormControl, InputGroup, Jumbotron, Modal, Row, Table,} from "react-bootstrap";
// import AReportTable from "./AReportTable";
import AlargerReportTable004A from "./AlargerReportTable004A";
import BReportTable004A from "./BReportTable004A";
import BReportTable004ACT from "./BReportTable004ACT";
import CmReportTable004A from "./CmReportTable004A";
import AReportTable004A from "./AReportTable004A";
import AsmallerReportTable004A from "./AsmallerReportTable004A";
import AnotherReportsListSidebar from "./AnotherReportsListSidebar";


const A004PromisT_all = (props) => {
 return (<>
        <AdminNavbar/>
        <Jumbotron>
            <Container fluid={true} style={{paddingBottom: "30px"}}>

                <Row>
                    <Col>
                        <h1>Converted PROMIS Scores, by Visit</h1>
                        {/* <div className="TitleCb">includes all participant scores</div> */}
                    </Col>
                </Row>
            </Container>
        </Jumbotron>
        <AnotherReportsListSidebar/>
    
       

     {/* <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "30px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "30px"}}>
            <div className="TitleC">PROMIS Subscale Means</div>
            <CmReportTable004A tableKey={"promisTMeans_004"}></CmReportTable004A>
                </div>
                </Container> */}
 

        <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "30px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "30px"}}>
            <div className="TitleC">ACT PROMIS Pain Interference</div> <div className="norms">4 questions, 1-5pts, max=20; goal: decreased scores</div>
            <BReportTable004ACT tableKey={"promisPI_converted_ACT_004A"}></BReportTable004ACT>
                </div>
                </Container>
        <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "30px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "30px"}}>
            <div className="TitleC">ST PROMIS Pain Interference</div> <div className="norms">4 questions, 1-5pts, max=20; goal: decreased scores</div>
            <BReportTable004A tableKey={"promisPI_converted_ST_004A"}></BReportTable004A>
                </div>
        </Container>

        <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "30px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "30px"}}>
            <div className="TitleC">ACT PROMIS Ability to Participate in Social Roles & Activities</div> <div className="norms">4 questions, 1-5pts, max=20; goal: increased scores</div>
            <BReportTable004ACT tableKey={"promisAP_converted_ACT_004A"}></BReportTable004ACT>
                </div>
                </Container>
        <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "30px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "30px"}}>
            <div className="TitleC">ST PROMIS Ability to Participate in Social Roles & Activities</div> <div className="norms">4 questions, 1-5pts, max=20; goal: increased scores</div>
            <BReportTable004A tableKey={"promisAP_converted_ST_004A"}></BReportTable004A>
                </div>
        </Container>
        
        <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "30px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "30px"}}>
            <div className="TitleC">ACT PROMIS Physical Function</div> <div className="norms">4 questions, 1-5pts, max=20; goal: increased scores</div>
            <BReportTable004ACT tableKey={"promisPF_converted_ACT_004A"}></BReportTable004ACT>
                </div>
                </Container>
        <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "30px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "30px"}}>
            <div className="TitleC">ST PROMIS Physical Function</div> <div className="norms">4 questions, 1-5pts, max=20; goal: increased scores</div>
            <BReportTable004A tableKey={"promisPF_converted_ST_004A"}></BReportTable004A>
                </div>
        </Container>

        <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "30px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "30px"}}>
            <div className="TitleC">ACT PROMIS Cognitive Function</div> <div className="norms">4 questions, 1-5pts, max=20; goal: increased scores</div>
            <BReportTable004ACT tableKey={"promisCF_converted_ACT_004A"}></BReportTable004ACT>
                </div>
                </Container>
        <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "30px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "30px"}}>
            <div className="TitleC">ST PROMIS Cognitive Function</div> <div className="norms">4 questions, 1-5pts, max=20; goal: increased scores</div>
            <BReportTable004A tableKey={"promisCF_converted_ST_004A"}></BReportTable004A>
                </div>
        </Container>
        
    



        <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "30px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "30px"}}>
            <div className="TitleC">ACT PROMIS Fatigue in the past 7 days</div> <div className="norms">4 questions, 1-5pts, max=20; goal: decreased scores</div>
            <BReportTable004ACT tableKey={"promisFtq_converted_ACT_004A"}></BReportTable004ACT>
                </div>
        </Container>
        <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "30px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "30px"}}>
            <div className="TitleC">ST PROMIS Fatigue in the past 7 days</div> <div className="norms">4 questions, 1-5pts, max=20; goal: decreased scores</div>
            <BReportTable004A tableKey={"promisFtq_converted_ST_004A"}></BReportTable004A>
                </div>
        </Container>
        <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "30px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "30px"}}>
            <div className="TitleC">ACT PROMIS Sleep Disturbance in the past 7 days</div> <div className="norms">4 questions, 1-5pts, max=20; goal: decreased scores</div>
            <BReportTable004ACT tableKey={"promisSD_converted_ACT_004A"}></BReportTable004ACT>
                </div>
        </Container>
        <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "30px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "30px"}}>
            <div className="TitleC">ST PROMIS Sleep Disturbance in the past 7 days</div> <div className="norms">4 questions, 1-5pts, max=20; goal: decreased scores</div>
            <BReportTable004A tableKey={"promisSD_converted_ST_004A"}></BReportTable004A>
                </div>
        </Container>
        <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "30px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "30px"}}>
            <div className="TitleC">ACT PROMIS Anxiety in the past 7 days</div> <div className="norms">4 questions, 1-5pts, max=20; goal: decreased scores</div>
            <BReportTable004ACT tableKey={"promisAnx_converted_ACT_004A"}></BReportTable004ACT>
                </div>
        </Container>
        <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "30px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "30px"}}>
            <div className="TitleC">ST PROMIS Anxiety in the past 7 days</div> <div className="norms">4 questions, 1-5pts, max=20; goal: decreased scores</div>
            <BReportTable004A tableKey={"promisAnx_converted_ST_004A"}></BReportTable004A>
                </div>
        </Container>

       
        <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "30px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "30px"}}>
            <div className="TitleC">ACT PROMIS Depression in the past 7 days</div> <div className="norms">4 questions, 1-5pts, max=20; goal: decreased scores</div>
            <BReportTable004ACT tableKey={"promisDS_converted_ACT_004A"}></BReportTable004ACT>
                </div>
        </Container>
        <Container fluid={true} style={{backgroundColor: "white", paddingLeft: "30px"}}>
            <div className="article" style={{paddingBottom: "30px", paddingLeft: "30px"}}>
            <div className="TitleC">ST PROMIS Depression in the past 7 days</div> <div className="norms">4 questions, 1-5pts, max=20; goal: decreased scores</div>
            <BReportTable004A tableKey={"promisDS_converted_ST_004A"}></BReportTable004A>
                </div>
        </Container>           

    
</>);

};

export default A004PromisT_all;




